import iconPath from '@/assets/device-icons/macbook-air.svg';

interface MacbookAirIconProps {
  className?: string;
}

export const MacbookAirIcon = ({ className = "h-5 w-5" }: MacbookAirIconProps) => {
  return (
    <img 
      src={iconPath} 
      alt="MacBook Air" 
      className={className}
    />
  );
};
